import {reducerWithInitialState} from "typescript-fsa-reducers";
import { languageActions } from "../actions/LanguageAction";
import { deepCopyTableThingyState, LanguageInitialState } from "../typing/languagestate";

export default reducerWithInitialState(LanguageInitialState)
        .case(languageActions.languageChange, (state,payload) => {
            console.log("Change languiagaction");
            console.log(payload, state);
            const deepCopy=deepCopyTableThingyState(state);
            deepCopy.model.language = payload.Language.language;
            return deepCopy;
        })
        .case(languageActions.toggleLanguage, (state, payload) => {
            console.log("Change languiagaction");
            const deepCopy=deepCopyTableThingyState(state);
            if (deepCopy.model.language === "de-DE")
                deepCopy.model.language = "en-EN";
            else 
                deepCopy.model.language = "de-DE";
            console.log(deepCopy.model.language);
            return deepCopy;
        })
        ;

        /// Props call immer [ber dispatch und diesen effekt